// Profit and Loss action types

// profit and loss statement data from date range sent
export const PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT =
  "PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT";
export const PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SUCCESS =
  "PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SUCCESS";
export const PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_ERROR =
  "PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_ERROR";
